import React from 'react'
import * as S from './styles'

type Props = {
  loading: boolean
}
export default function PageLoading({ loading }: Props) {
  return loading ? (
    <S.LoadingBackground>
      <S.LoadingWrap>
        <S.LoadingIconWrap />
        <S.LoadingTit>Page Loading</S.LoadingTit>
      </S.LoadingWrap>
    </S.LoadingBackground>
  ) : null
}
